/* unplugin-vue-components disabled */import { render } from "./Index.vue?vue&type=template&id=7d5b1587&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=7d5b1587&lang=stylus&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d5b1587"]])

export default __exports__